<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Edit New
      Feedback & Complaint</a>
    <FormFeedback v-if="!$store.state.loading" v-model="data" @submit="onSubmit" ref="formFeedback"
      @on-delete="deleteFeedback" />
  </main>
</template>
<script>
import axios from '@/axios';
import FormFeedback from "@/components/form/feedback";
import { showErrorMessage } from '@/utils';
import { objectToFormData } from '@/utils/formdata';
import structuredClone from 'core-js/actual/structured-clone';
import moment from 'moment'

export default {
  components: {
    FormFeedback
  },
  data() {
    return {
      data: {},
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formFeedback.$validator.validateAll();
      if (isValid) {
        let cloneData = structuredClone(this.data);

        if (typeof cloneData.photo === 'string') {
          delete cloneData.photo;
        }
        delete cloneData.prepared_by

        const data = objectToFormData(cloneData);
        try {
          this.$store.dispatch('toggleLoadingProgress', true)
          await axios.post(`/fnc/${this.$route.params.id}`, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          this.$notify({ type: 'success', text: 'Success adding feedback and complaint' })
          this.$router.go(-1)
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    },
    deleteFeedback() {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.delete(`/fnc/${this.$route.params.id}`)
          .then(() => {
            this.$notify({ type: 'success', title: 'Success', text: 'Success delete data' })
            this.$router.push('/feedback')
          }).catch(error => {
            showErrorMessage(error)
          }).finally(() => {
            this.$store.dispatch('toggleLoadingProgress', false)
          })
      }
    },
  },
  async created() {
    try {
      this.$store.dispatch('toggleLoadingProgress', true)
      const response = await axios.get(`/fnc/${this.$route.params.id}`)
      if (response.status == 200) {
        const { data } = response?.data
        this.data = {
          id: data?.id,
          date_time: moment(data?.date_time, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          type: data?.type,
          description: data?.description,
          category_id: {
            text: data?.category?.name,
            value: data?.category_id,
            _data: { ...data?.category }
          },
          priority: data?.priority,
          assign_to: data?.assigneds?.map(assigned => ({
            text: assigned?.assignee?.code ?? assigned?.assignee?.name,
            value: assigned?.assignee_id,
            _data: { ...assigned?.assignee }
          })),
          customer_id: {
            text: data?.customer?.name,
            value: data?.customer_id
          },
          product: data?.product,
          photo: data?.photos,
          pic_id: {
            text: data?.pic?.name,
            value: data?.pic_id,
          },
          no_hp_pic: data?.no_hp_pic,
          grade: data?.grade,
          location: data?.location,
          lot_no: data?.lot_no,
          shipment_date: moment(data?.shipment_date, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          issue: data?.issue,
          transporter_id: {
            text: data?.transporter?.name,
            value: data?.transporter_id
          },
          no_surat_jalan: data?.no_surat_jalan,
          tgl_surat_jalan: moment(data?.tgl_surat_jalan, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          deadline_date: moment(data?.deadline_date, 'YYYY-MM-DD').format('DD-MM-YYYY'), // miss
          end_product_application: data?.end_product_application, // miss

          // hook
          prepared_by: data?.prepared_by_detail?.name
        }
      }
    } catch (error) {
      showErrorMessage(error)
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
  }
}
</script>

<style></style>
